import { VendorEntity } from "../../features/bills/domain/entities/VendorEntity";
import { Currency } from "../data/api/currenciesApi";
import { GSTINVerificationResult } from "../data/api/gstinVerificationApi";
import { findCountryByCode } from "../constants/countries";
import { getCurrencyIdForCountry } from "./countryCurrency";
import { extractPanFromGstin } from "./gstinUtils";

export interface GstinPrefillField {
  label: string;
  currentValue: string;
  newValue: string;
}

export function buildVendorGstinPrefillFields(
  formData: Partial<VendorEntity>,
  verificationData: GSTINVerificationResult | null,
  gstin: string,
  currencies: Currency[],
): GstinPrefillField[] {
  const pan = extractPanFromGstin(gstin);
  const inrCurrency = currencies.find((c) => c.currency_code === "INR");
  const currentCurrencyName = formData.currency_id
    ? currencies.find((c) => c.currency_id === formData.currency_id)
        ?.currency_name || ""
    : "";

  return [
    {
      label: "Vendor Name",
      currentValue: (formData.vendor_legal_name as string) || "",
      newValue: verificationData?.legal_name || "",
    },
    {
      label: "Address",
      currentValue: (formData.registered_office_address as string) || "",
      newValue: verificationData?.address || "",
    },
    {
      label: "State",
      currentValue: (formData.state as string) || "",
      newValue: verificationData?.state || "",
    },
    {
      label: "City",
      currentValue: (formData.city as string) || "",
      newValue: verificationData?.city || "",
    },
    {
      label: "Postal Code",
      currentValue: (formData.postal_code as string) || "",
      newValue: verificationData?.pincode || "",
    },
    {
      label: "Country",
      currentValue: formData.country
        ? findCountryByCode(formData.country)?.name || formData.country
        : "",
      newValue: findCountryByCode("IN")?.name || "India",
    },
    {
      label: "PAN ID",
      currentValue: (formData.pan_tax_id as string) || "",
      newValue: pan || "",
    },
    {
      label: "Currency",
      currentValue: currentCurrencyName,
      newValue: inrCurrency?.currency_name || "INR",
    },
  ];
}

export function buildVendorGstinPrefillUpdates(
  verificationData: GSTINVerificationResult | null,
  gstin: string,
  currencies: Currency[],
): Partial<VendorEntity> {
  const pan = extractPanFromGstin(gstin);
  const currencyId = getCurrencyIdForCountry("IN", currencies);

  const updates: Partial<VendorEntity> = { country: "IN" };

  if (verificationData?.legal_name) {
    updates.vendor_legal_name = verificationData.legal_name;
  }
  if (verificationData?.address) {
    updates.registered_office_address = verificationData.address;
  }
  if (verificationData?.state) {
    updates.state = verificationData.state;
  }
  if (verificationData?.city) {
    updates.city = verificationData.city;
  }
  if (verificationData?.pincode) {
    updates.postal_code = verificationData.pincode;
  }
  if (pan) {
    updates.pan_tax_id = pan;
  }
  if (currencyId) {
    updates.currency_id = currencyId;
  }

  return updates;
}
